export enum RequestTypes {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export enum ApiVersions {
  CHAT = '5',
}

/** Mirrors IAction from the mobile repo — drives action-name, phi-* headers, and owns its URL. */
export interface IAction {
  Name: string;        // → action-name header
  Type: string;        // → phi-action-type header
  Description: string; // → phi-action-description header
  ContentType?: string;
  /** Returns the endpoint URL, optionally interpolating dynamic segments from obj. */
  Url: (obj?: Record<string, unknown>) => string;
}

export interface IParams {
  [key: string]: unknown;
  /** Extracted for request headers — NOT forwarded as a URL query param. */
  action?: IAction;
  /** Extracted for phi-patient-name header — NOT forwarded as a URL query param. */
  patientName?: string;
}

export interface IHeaders {
  [key: string]: string;
}

export interface ApiResponse<T> {
  status: 'success' | 'error';
  data?: T;
  statusCode?: number;
  timeStamp?: Date | string;
  message?: string;
  response?: unknown;
}
